import { EmployeeResponse } from 'api/services/workforce/workforce-service.types';
import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';
import { DetailColumn, DetailSection } from 'redesign';
import { getEmploymentTypeLabel } from '../../utils/get-employment-type-label';

type Props = {
  data: EmployeeResponse;
};

export const EmployeeInformationTab = ({ data }: Props) => {
  const { t } = useTranslation(['all-platforms-common', 'web-common']);

  const columns: DetailColumn[] = [
    {
      items: [
        {
          title: t('worker_data.first_name', { ns: 'all-platforms-common' }),
          value: data.firstName,
        },
        {
          title: t('worker_data.email', { ns: 'all-platforms-common' }),
          value: data.email,
        },
        {
          title: t('worker_data.postal_code', { ns: 'all-platforms-common' }),
          value: data.location?.postalCode,
        },
        {
          title: t('contract.start_date', { ns: 'all-platforms-common' }),
          value: data.contractStartDate
            ? DateTime.fromISO(data.contractStartDate).toLocaleString(DateTime.DATE_MED, {
                locale: 'nl',
              })
            : undefined,
        },
      ],
    },
    {
      items: [
        {
          title: t('worker_data.infix', { ns: 'all-platforms-common' }),
          value: data.infix,
        },
        {
          title: t('worker_data.street', { ns: 'all-platforms-common' }),
          value: data.location?.street,
        },
        {
          title: t('worker_data.city', { ns: 'all-platforms-common' }),
          value: data.location?.city,
        },
        {
          title: t('contract.end_date', { ns: 'all-platforms-common' }),
          value: data.contractEndDate
            ? DateTime.fromISO(data.contractEndDate).toLocaleString(DateTime.DATE_MED, {
                locale: 'nl',
              })
            : undefined,
        },
      ],
    },
    {
      items: [
        {
          title: t('worker_data.last_name', { ns: 'all-platforms-common' }),
          value: data.lastName,
        },
        {
          title: t('worker_data.house_number', { ns: 'all-platforms-common' }),
          value: data.location?.houseNumber,
        },
        {
          title: t('worker_data.contract_hours', { ns: 'all-platforms-common' }),
          value: data.contractMinutes != null ? `${data.contractMinutes / 60} uur` : '0 uur',
        },
        {
          title: t('worker_data.employment_type', { ns: 'all-platforms-common' }),
          value: getEmploymentTypeLabel(data.employmentType, (key) => t(key, { ns: 'web-common' })),
        },
      ],
    },
  ];

  return <DetailSection columns={columns} />;
};
